/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WarehousePackageOrderItemDTOFromJSON, WarehousePackageOrderItemDTOToJSON, } from './WarehousePackageOrderItemDTO';
import { SupplierDeliveryDTOFromJSON, SupplierDeliveryDTOToJSON, } from './SupplierDeliveryDTO';
/**
 * @export
 */
export const WarehousePackageListItemDTOPackageStatusEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * @export
 */
export const WarehousePackageListItemDTODispatchModeEnum = {
    Ship: 'SHIP',
    Hold: 'HOLD',
    NotComing: 'NOT_COMING'
};
/**
 * Check if a given object implements the WarehousePackageListItemDTO interface.
 */
export function instanceOfWarehousePackageListItemDTO(value) {
    return true;
}
export function WarehousePackageListItemDTOFromJSON(json) {
    return WarehousePackageListItemDTOFromJSONTyped(json, false);
}
export function WarehousePackageListItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'warehousePackageId': json['warehousePackageId'] == null ? undefined : json['warehousePackageId'],
        'amazonOrderId': json['amazonOrderId'] == null ? undefined : json['amazonOrderId'],
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'shippinglotStatus': json['shippinglotStatus'] == null ? undefined : json['shippinglotStatus'],
        'initialWarehouseCostUsd': json['initialWarehouseCostUsd'] == null ? undefined : json['initialWarehouseCostUsd'],
        'warehouseCostUsd': json['warehouseCostUsd'] == null ? undefined : json['warehouseCostUsd'],
        'carrierName': json['carrierName'] == null ? undefined : json['carrierName'],
        'carrierService': json['carrierService'] == null ? undefined : json['carrierService'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'trackingUrl': json['trackingUrl'] == null ? undefined : json['trackingUrl'],
        'receivedAt': json['receivedAt'] == null ? undefined : (new Date(json['receivedAt'])),
        'sentFromWarehouseDate': json['sentFromWarehouseDate'] == null ? undefined : (new Date(json['sentFromWarehouseDate'])),
        'buyerName': json['buyerName'] == null ? undefined : json['buyerName'],
        'manualFulfillment': json['manualFulfillment'] == null ? undefined : json['manualFulfillment'],
        'shipmentHoldAt': json['shipmentHoldAt'] == null ? undefined : (new Date(json['shipmentHoldAt'])),
        'warehouseCancelledAt': json['warehouseCancelledAt'] == null ? undefined : (new Date(json['warehouseCancelledAt'])),
        'dispatchMode': json['dispatchMode'] == null ? undefined : json['dispatchMode'],
        'supplierDelivery': json['supplierDelivery'] == null ? undefined : SupplierDeliveryDTOFromJSON(json['supplierDelivery']),
        'orderItems': json['orderItems'] == null ? undefined : (json['orderItems'].map(WarehousePackageOrderItemDTOFromJSON)),
    };
}
export function WarehousePackageListItemDTOToJSON(json) {
    return WarehousePackageListItemDTOToJSONTyped(json, false);
}
export function WarehousePackageListItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'warehousePackageId': value['warehousePackageId'],
        'amazonOrderId': value['amazonOrderId'],
        'packageStatus': value['packageStatus'],
        'shippinglotStatus': value['shippinglotStatus'],
        'initialWarehouseCostUsd': value['initialWarehouseCostUsd'],
        'warehouseCostUsd': value['warehouseCostUsd'],
        'carrierName': value['carrierName'],
        'carrierService': value['carrierService'],
        'trackingNumber': value['trackingNumber'],
        'trackingUrl': value['trackingUrl'],
        'receivedAt': value['receivedAt'] == null ? undefined : ((value['receivedAt']).toISOString()),
        'sentFromWarehouseDate': value['sentFromWarehouseDate'] == null ? undefined : ((value['sentFromWarehouseDate']).toISOString()),
        'buyerName': value['buyerName'],
        'manualFulfillment': value['manualFulfillment'],
        'shipmentHoldAt': value['shipmentHoldAt'] == null ? undefined : ((value['shipmentHoldAt']).toISOString()),
        'warehouseCancelledAt': value['warehouseCancelledAt'] == null ? undefined : ((value['warehouseCancelledAt']).toISOString()),
        'dispatchMode': value['dispatchMode'],
        'supplierDelivery': SupplierDeliveryDTOToJSON(value['supplierDelivery']),
        'orderItems': value['orderItems'] == null ? undefined : (value['orderItems'].map(WarehousePackageOrderItemDTOToJSON)),
    };
}
